import { useEffect, MutableRefObject, useState } from 'react'

const usePlayerFullScreen = ({
  playerRef,
}: {
  playerRef: MutableRefObject<any>
}) => {
  const player = playerRef.current?.player?.()
  const playerNode = player?.el_ as HTMLElement
  const hasPlayerFullScreenClass =
    playerNode?.classList?.contains('vjs-fullscreen')

  const [isFullScreen, setIsFullScreen] = useState<boolean>(false)

  useEffect(() => {
    const fullScreenChangeHandler = () => {
      setIsFullScreen(!!player?.isFullscreen?.())
    }

    player?.on('fullscreenchange', fullScreenChangeHandler)

    return () => {
      player?.off('fullscreenchange', fullScreenChangeHandler)
    }
  }, [player, playerNode])

  useEffect(() => {
    setIsFullScreen(hasPlayerFullScreenClass)
  }, [hasPlayerFullScreenClass])

  return [isFullScreen]
}

export default usePlayerFullScreen
